import React from 'react';
import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import IosShareIcon from '@mui/icons-material/IosShare';
import LogoutIcon from '@mui/icons-material/Logout';
import QuickView from './quickView';
import SidebarRecommended from './recommended';
import KeyInsight from './keyInsight';
import useSidebarData from './useSidebarData';
import * as styles from './styles';

function ManageSidebar({ subscriber, activePanel, onSelect, onSignOut, onShare, onSync }) {
    const { quickViewItems, recommendedPublishers, keyInsight } = useSidebarData();

    const initials = subscriber
        ? `${subscriber.firstName?.[0] || ''}${subscriber.lastName?.[0] || ''}`
        : '?';

    const displayName = subscriber
        ? `${subscriber.firstName || ''} ${subscriber.lastName || ''}`.trim()
        : '';

    function renderNavLink(id, icon, label) {
        return (
            <Box
                component="button"
                onClick={() => onSelect(id)}
                sx={styles.navLink(activePanel === id)}
            >
                {icon}
                {label}
            </Box>
        );
    }

    function renderProfileCard() {
        return (
            <Box sx={styles.card}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={styles.avatar}>{initials}</Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography sx={styles.displayName}>{displayName}</Typography>
                        <Typography sx={styles.persona}>{subscriber?.email}</Typography>
                    </Box>
                </Box>

                <Box sx={styles.nav}>
                    {renderNavLink('subscriptions', <CalendarMonthIcon sx={{ fontSize: 18 }} />, 'My Subscriptions')}
                    {renderNavLink('profile', <PersonIcon sx={{ fontSize: 18 }} />, 'My Profile')}
                    <Box component="button" onClick={onShare} sx={styles.navLink(false)}>
                        <IosShareIcon sx={{ fontSize: 18 }} />
                        Share with Friends
                    </Box>
                    <Box component="button" onClick={onSignOut} sx={styles.navLink(false)}>
                        <LogoutIcon sx={{ fontSize: 18 }} />
                        Sign Out
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={styles.aside}>
            {renderProfileCard()}

            <QuickView
                items={quickViewItems}
                onManage={() => onSelect('subscriptions')}
            />

            <SidebarRecommended
                publishers={recommendedPublishers}
                onSync={onSync}
            />

            {/* TODO: re-enable when insight data is ready
            <KeyInsight
                eventsThisMonth={keyInsight.eventsThisMonth}
                timeBooked={keyInsight.timeBookedLabel}
                percentOfMonth={keyInsight.scheduleDensityPct}
            />
            */}
        </Box>
    );
}

export default observer(ManageSidebar);
